import React from 'react';
import PropTypes from 'prop-types';
import StylePropType from 'react-style-proptype';
import Radium from 'radium';
import Styles from './styles';

class Button extends React.Component {
  render() {
    const { size, type, width, style, text, buttonStyle, ...rest } = this.props;
    const { label = {} } = style;
    return (
      <div
        key="wrapper"
        style={[
          Styles.base,
          Styles.sizes[size],
          type === 'filled' ? Styles.filled : {},
          type === 'outline' ? Styles.outline : {},
          width === 'full' ? Styles.fullWidth : {},
          style,
        ]}
      >
        <button
          key="button"
          type={type}
          style={[
            Styles.button,
            Styles.buttonSizes[size],
            type === 'outline' || type === 'none' ? Styles.buttonAltText : {},
            this.props.buttonStyle,
            label,
          ]}
          {...rest}
        >
          {this.props.children}
        </button>
      </div>
    );
  }
}

Button.propTypes = {
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  type: PropTypes.oneOf(['filled', 'outline', 'none', 'submit']),
  width: PropTypes.oneOf(['auto', 'full']),
  style: StylePropType,
  buttonStyle: StylePropType,
  children: PropTypes.node,
};

Button.defaultProps = {
  size: 'md',
  type: 'filled',
  width: 'auto',
  style: {},
  buttonStyle: {},
  children: null,
};

export default Radium(Button);



// WEBPACK FOOTER //
// ./src/components/UIKit/Button/index.js